import type { CoreItemPhoto, ParameterID } from '@flecto/types'

import { api } from '../../../services/api'
import { deserialize } from '../../../services/deserialize'

/**
 * Get all item photos by ID.
 *
 * @endpoint GET /api/saas/me/items/{itemId}/photos
 * @scope saas
 * @see https://flecto.dev/api-4724237
 */
export async function getAllItemPhotos(
  itemId: ParameterID
): Promise<CoreItemPhoto[]> {
  const response = await api.get(`/api/saas/me/items/${itemId}/photos`)
  const { data } = deserialize<CoreItemPhoto[]>(response.data)

  return data
}
